/* Mobile scroll fix + cart drawer fix — April 5 2026 v5 (Safari white screen fix) */
(function(){
  function isKlaviyoPopupVisible() {
    var popups = document.querySelectorAll('.klaviyo-form');
    for (var i = 0; i < popups.length; i++) {
      var p = popups[i];
      var s = getComputedStyle(p);
      if (s.display !== "none" && s.visibility !== "hidden" && s.opacity !== "0" && p.offsetHeight > 50) {
        return true;
      }
    }
    return false;
  }

  function isDrawerOpen() {
    var b = document.body;
    return b.classList.contains("cart-opened") || b.classList.contains("menu-opened") || b.classList.contains("login-opened");
  }

  function unlockScroll() {
    if (isDrawerOpen()) return;
    if (isKlaviyoPopupVisible()) return;

    var body = document.body;
    var html = document.documentElement;

    /* Remove Klaviyo scroll lock class */
    body.classList.remove("klaviyo-prevent-body-scrolling");

    /* Fix body scroll lock — Klaviyo sets overflow:hidden + position:fixed on body */
    body.style.overflow = "";
    body.style.overflowY = "";
    body.style.overflowX = "";
    body.style.position = "";
    body.style.top = "";
    body.style.left = "";
    body.style.width = "";

    /* v5 FIX: Also fix html element — Klaviyo newer versions lock <html> too.
       This was the Safari white screen root cause. */
    html.style.overflow = "";
    html.style.overflowY = "";
    html.style.overflowX = "";

    /* Hide any large Klaviyo overlay containers that are stuck open */
    document.querySelectorAll('[class*="kl-private-reset-css"]').forEach(function(el) {
      var s = getComputedStyle(el);
      if (s.position === "fixed" && el.offsetWidth > 500 && el.offsetHeight > 500) {
        var visibleForm = el.querySelector(".klaviyo-form");
        if (!visibleForm || getComputedStyle(visibleForm).display === "none") {
          el.style.display = "none";
        }
      }
    });
  }

  var obs = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].attributeName === "class" || mutations[i].attributeName === "style") {
        setTimeout(unlockScroll, 300);
        break;
      }
    }
  });

  function init() {
    /* Watch body for Klaviyo class/style changes */
    obs.observe(document.body, { attributes: true, attributeFilter: ["class", "style"] });

    /* v5 FIX: Also watch html element — Klaviyo can lock this directly */
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["style"] });

    unlockScroll();

    /* Catch any missed unlocks on tap */
    document.addEventListener("click", function() { setTimeout(unlockScroll, 300); });
    document.addEventListener("touchend", function() { setTimeout(unlockScroll, 150); });
  }

  if (document.body) init();
  else document.addEventListener("DOMContentLoaded", init);
})();
